<template>
  <div>
    <v-row no-gutters>
      <v-spacer />
      <load-builder-template @input="templateSetter" />
      <save-builder-template :template-getter="templateGetter" />
    </v-row>
    <v-row class="my-6" no-gutters>
      <v-col data-userflow-id="email-editor" cols="12">
        <email-editor
          ref="emailEditor"
          :appearance="appearance"
          :project-id="projectId"
          :locale="locale"
          :tools="tools"
          :options="options"
          @load="editorLoaded"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { EmailEditor } from 'vue-email-editor'
import { isEmpty } from 'lodash'
import { characterVariables } from '@/mixins/character-variables'
export default {
  components: {
    EmailEditor,
    LoadBuilderTemplate: () => import('@/modules/campanhas/campanhas-email/views/components/builder-templates/LoadBuilderTemplate.vue'),
    SaveBuilderTemplate: () => import('@/modules/campanhas/campanhas-email/views/components/builder-templates/SaveBuilderTemplate.vue'),
  },

  mixins: [characterVariables],

  props: {
    value: {
      type: Object,
      default: () => {},
    },
    isMariaCampaignActivated: {
      type: Boolean,
      default: false,
    },
    isMariaCampaignFinished: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    validations: {
      type: Object,
      default: () => {},
    },
  },

  data: () => ({
    localBuilderConfiguration: null,
    localProcessedHtml: null,
  }),

  computed: {
    appearance() {
      return {
        theme: 'dark',
        panels: {
          tools: {
            dock: 'right',
          },
        },
      }
    },
    projectId() {
      return 203339
    },
    locale() {
      return 'pt-BR'
    },
    tools() {
      return {
        image: {
          enabled: true,
        },
      }
    },
    bestItemsVariables() {
      if (!this.isMariaCampaign) return []
      const label = `${this.getBestProductText}, do dia {inicio validade} ate {fim validade}]`
      const variableInfo = {
        description: '- Exibe, dos produtos em promoção, qual o consumidor tem mais chance de comprar seguindo os critérios incluso na campanha.',
        charQuantity: this.bestProductCharQuantity,
      }
      return [
        {
          clipboardText: `[primeiro ${label}`,
          text: `[primeiro ${label}`,
          ...variableInfo,
        },
        {
          clipboardText: `[segundo ${label}`,
          text: `[segundo ${label}`,
          ...variableInfo,
        },
        {
          clipboardText: `[terceiro ${label}`,
          text: `[terceiro ${label}`,
          ...variableInfo,
        },
      ]
    },
    builderEmailVariables() {
      const excludedVariables = [
        '{fim validade}',
        '{inicio validade}',
        '{nome do combo}',
        '{nome produto}',
        '{preço 1}',
        '{preço 2}',
        '{desconto}',
        '{leve}',
        '{pague}',
        'primeiro melhor produto ',
        'segundo melhor produto ',
        'terceiro melhor produto ',
        'primeiro melhor combo ',
        'segundo melhor combo ',
        'terceiro melhor combo ',
        'Melhor produto',
        'Melhor combo',
      ]

      return this.variables
        .filter((item) => !excludedVariables.includes(item.clipboardText) && !['Melhor produto', 'Melhor combo'].includes(item.text))
        .concat(this.bestItemsVariables)
    },
    options() {
      return {
        translations: {
          'pt-BR': {
            'labels.merge_tags': 'Variáveis',
          },
        },

        mergeTags: this.builderEmailVariables.reduce((acc, variable) => {
          return {
            [variable.clipboardText]: {
              value: variable.clipboardText,
              name: variable.text,
              sample: variable.example,
            },
            ...acc,
          }
        }, {}),
      }
    },
  },

  created() {
    if (!isEmpty(this.value?.message?.builder_email_configuration)) {
      this.localBuilderConfiguration = this.value?.message?.builder_email_configuration
    }
  },
  methods: {
    editorLoaded() {
      if (!this.localBuilderConfiguration) return
      this.$refs.emailEditor.editor.loadDesign(this.localBuilderConfiguration)
    },
    async exportDesign() {
      return new Promise((resolve) => this.$refs.emailEditor.editor.saveDesign(resolve))
    },
    async exportHtml() {
      return new Promise((resolve) => this.$refs.emailEditor.editor.exportHtml((data) => resolve(data.html)))
    },
    async getConfiguration() {
      return {
        processed_html: await this.exportHtml(),
        builder_email_configuration: await this.exportDesign(),
      }
    },
    async templateGetter() {
      const configuration = await this.exportDesign()
      return configuration
    },
    templateSetter(emailTemplate) {
      this.$refs.emailEditor.editor.loadDesign(emailTemplate.configuration)
    },
    isTouched() {
      return true
    },
  },
}
</script>

<style lang="scss">
.unlayer-editor {
  height: 1000px;
}
</style>
